import { SEO } from "@/components/SEO";
import { LeadCalculatorTool } from "@/components/lead-calculator/LeadCalculatorTool";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const LeadCalculator = () => {
  const breadcrumbItems = [
    { label: "Lead Calculator" }
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Lead Value Calculator for Contractors in OKC | Home Pros OKC"
        description="Calculate potential revenue and profit from your leads. Use our free calculator to estimate the value of contractor leads in Oklahoma City."
        canonicalUrl="/lead-calculator"
      />
      
      <div className="container mx-auto px-4 py-8">
        <Breadcrumbs items={breadcrumbItems} />
        <LeadCalculatorTool />
      </div>
    </div>
  );
};

export default LeadCalculator;
